import { render, staticRenderFns } from "./SubtitleBar.vue?vue&type=template&id=0b2928b5&"
import script from "./SubtitleBar.vue?vue&type=script&lang=js&"
export * from "./SubtitleBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports